export default {"src":"/polygon/_next/static/media/polygon.0b14a515.svg","height":10,"width":12};